import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { RecruitmentApiService } from '../../services/recruitment-api.service';

@Component({
  selector: 'app-recruitment-shell',
  templateUrl: './recruitment-shell.component.html',
  styleUrls: ['./recruitment-shell.component.css'],
  standalone: false,
})
export class RecruitmentShellComponent implements OnInit, OnDestroy {
  mobileNavigationOpen = false;
  private querySubscription?: Subscription;

  constructor(
    private authService: AuthService,
    private route: ActivatedRoute,
    private recruitmentApi: RecruitmentApiService
  ) {}

  ngOnInit(): void {
    this.querySubscription = this.route.queryParamMap.subscribe((params) => {
      this.recruitmentApi.setOrganizationContext(params.get('orgId'));
    });
  }

  ngOnDestroy(): void {
    this.querySubscription?.unsubscribe();
    this.recruitmentApi.setOrganizationContext(null);
  }

  get recruiterEmail(): string {
    return this.authService.getCurrentUser()?.email || 'Recruiter';
  }

  get isAdmin(): boolean {
    return this.authService.getCurrentUser()?.role === 'admin';
  }

  closeMobileNavigation(): void {
    this.mobileNavigationOpen = false;
  }

  signOut(): void {
    this.authService.logout();
  }
}
